<template>
  <div class="session-block">
    <transition-group name="list-complete" class="session-block" mode="out-in">
      <div class="session list-complete-item" v-for="item in data" :key="item.id">
        <img class="session-header" v-if="item.image != null" :src="$imageus + item.image + '?width=460&height=205&mode=cover'" alt="" />
        <img class="session-header" v-if="item.image == null" src="/static/1120x500.png" alt="" />

        <div class="session-type" v-if="type != null">
          <span :style="'background-color: ' + currentEvent.color">{{ type }}</span>
        </div>

        <div class="session-card">
          <div class="session-left">
            <div class="session-info">
              <span style="color: #ff7511;" v-if="item.isLive == false">
                <img src="/static/menuicons/waiting-clock.svg" />
                {{ $t("sessions.waiting") }}
              </span>
              <span style="color: #f22f2f;" v-if="item.isLive == true">
                <img src="/static/menuicons/video-cam.svg" />
                {{ $t("sessions.live") }}
              </span>
              <span>● {{ moment(item.startDate.replace("Z", "")).fromNow() }}</span>
            </div>

            <div class="session-title">
              <p>{{ item.title }}</p>
            </div>
          </div>

          <div class="session-right">
            <button :style="'background-color: ' + currentEvent.color" @click="$store.dispatch('joinSession', item.id)">
              <span v-if="$store.state.sessionLoadingID != item.id">{{ $t("sessions.join") }}</span>
              <span v-if="$store.state.sessionLoadingID == item.id"><i class="fa fa-spinner spin"></i></span>
              <!-- <md-progress-spinner style="transition: 0s !important;" v-if="$store.state.sessionLoadingID == item.id" class="md-accent" :md-diameter="15" :md-stroke="3" md-mode="indeterminate"></md-progress-spinner> -->
            </button>
          </div>
        </div>
      </div>
    </transition-group>
  </div>
</template>

<script>
import moment from "moment/min/moment-with-locales";
export default {
  name: "SessionBlock",
  props: ["data", "type"],
  data() {
    return {
      moment
    };
  },
  computed: {
    currentEvent() {
      return this.$store.getters.getEvent;
    }
  }
};
</script>

<style lang="less">
.session-block {
  display: contents;

  .session {
    width: 100%;
    position: relative;
    h4,
    h5 {
      margin: 0;
    }

    .session-type {
      position: absolute;
      top: 10px;
      left: 12px;

      span {
        padding: 4px 8px;
        border-radius: 15px;
        border: 2px solid #fff;
        color: #ffffff;
        font-weight: 500;
        font-size: 12px;
      }
    }

    .session-header {
      width: 100%;
      height: auto;
      border-top-right-radius: 8px;
      border-top-left-radius: 8px;
      box-shadow: rgba(0, 0, 0, 0.16) 0px 0px 3px;
    }

    .session-card {
      justify-content: space-around;
      flex-direction: row;
      align-items: center;
      display: flex;
      background-color: #fff;
      padding: 8px 10px;
      // border: 0.5px solid #D6D9D9;
      box-shadow: rgba(0, 0, 0, 0.16) 0px 0px 3px;
      border-top: none;
      border-bottom-right-radius: 8px;
      border-bottom-left-radius: 8px;

      .session-left {
        display: flex;
        flex: 1;
        flex-direction: column;
        justify-content: center;
        margin-left: 6px;

        .session-info {
          margin: 0px;

          span {
            color: #8c929c;
            font-size: 12px;
            img {
              width: 12px;
              height: 12px;
              margin-right: 6px;
            }
          }
        }

        .session-title {
          line-height: 16px;
          display: inline-grid;

          p {
            text-overflow: ellipsis;
            max-width: 240px !important;
            white-space: nowrap;
            overflow: hidden;
            margin: 0px;
            display: block;
            color: #292f3b;
            font-weight: 500;
            font-size: 14px;
          }
        }
      }

      .session-right {
        button {
          border: none;
          outline: none;
          padding: 8px 15px;
          background-color: whitesmoke;
          font-weight: bold;
          color: white;
          margin-left: 15px;
          border-radius: 16px;
          font-family: "Roboto";
          cursor: pointer;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/modules/SessionBlock.vue